app.controller('ProgramOfferCtrl', function ($scope, $rootScope, $http, $element, $uibModal, loginService) {
    this.user = loginService.currentUser;

    $rootScope.$on("notificationOpenProgramOfferModel", function(event,param){
        $scope.openModel('openProgramOfferModal', param.offerId);
    });

    $scope.openModel = (modelName,offerId) => {
        if (modelName == 'openProgramOfferModal') {
            this.openProgramOfferModal(offerId);
        }
    };

    this.openProgramOfferModal = (offerId) => {
        if (offerId) {
            // Need to get data of program and offer.
            this.loading = true;
            $http
                .get(`/offer/details/${offerId}`)
                .then((response) => {
                    // open offer model
                    if (response.data.programOffer && response.data.programOffer.id) {
                        if (response.data.programOffer.status == "PENDING" || response.data.programOffer.status == "ACCEPT") {
                            this.customerOfferModal(response.data);
                        } else if (response.data.programOffer.status == "DECLINE" || response.data.programOffer.status == "CANCELLED"){
                            this.offerConfirmationModal(response.data, 'decline');
                        } else {
                            this.offerConfirmationModal(response.data, 'accept');
                        }
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    };

    this.customerOfferModal = (offerDetails) => {
        $uibModal
            .open({
                component: 'customer-offer',
                windowClass: 'customer-offer-modal',
                animation: false,
                size: 'md',
                resolve: {
                    offerDetails: () => {
                        return offerDetails;
                    }
                }
            })
            .result
            .then(onSuccess, onClose)
            .catch(onError('customer-offer'));
    };

    this.offerConfirmationModal = (offerDetails, targetAction) => {
        $uibModal
            .open({
                component: 'offer-confirmation',
                windowClass: 'offer-confirmation-modal',
                animation: false,
                size: 'md',
                resolve: {
                    offerDetails: () => {
                        return offerDetails;
                    },
                    targetAction: () => {
                        return targetAction;
                    }
                }
            })
            .result
            .then(onClose, onClose)
            .catch(onError('offer-confirmation'));
    };

    const onSuccess = (data) => {
        if (data.action == 'decline') {
            // open confirmation dialog box
            this.offerConfirmationModal(data.offerDetails, 'decline');
        } else if (data.action == 'accept') {
            // open payment step
            var $paynowBtn = $element.find('#btn-'+data.offerDetails.programOffer.id);
            $paynowBtn.click();
        }
    };

    const onClose = (data) => {
        // console.log(data);
    };

    const onError = (name) => {
        return (err) => {
            console.log('',err);
        };
    };

});